export default __webpack_public_path__ + "static/media/z3.5f10bb6b.webp";